module.exports = __webpack_public_path__ + "static/media/sala-comedor.a5921fb7.jpg";